/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs'

const $nsid = 'app.bsky.graph.getRelationships'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  actor: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  others: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' }), {
      maxLength: 30,
    }),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  actor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  relationships: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<GraphDefs.Relationship>(
          (() => GraphDefs.relationship) as any,
        ),
        /*#__PURE__*/ l.typedRef<GraphDefs.NotFoundActor>(
          (() => GraphDefs.notFoundActor) as any,
        ),
      ],
      false,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates public relationships between one account, and a list of other accounts. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['ActorNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
